export default __webpack_public_path__ + "static/Hayden-18149ec56ce2b4f8f02b73d13cb0f40f.svg";